module.exports = __webpack_public_path__ + "static/img/scene-7.b2fca311.jpg";